import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MultiModulePickerService {
  tabs= [];
  intialAssociatedModules: any;
  associatedModules = new Subject();
  defaultModule: string;

  constructor() { }

  setTabs(tabs): any{
    this.tabs = tabs;
  }
  getTabs(): any{
      return this.tabs;
  }
  setAssociatedModules(associatedModules): void{
    this.intialAssociatedModules = associatedModules;
  }
  getAssociatedModules(): any{
    return this.intialAssociatedModules;
  }
  getDefaultModule(): any{
    return this.defaultModule;
  }
  setDefaultModule(defaultModule): any{
    this.defaultModule = defaultModule;
  }
}
